<template>
  <div class="tw-w-12 tw-h-12">
    <router-link :to="`/profile/${data.profile.id}`">
      <img
        :src="thumb"
        class="tw-rounded-full"
      >
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['data'],

  computed: {
    thumb() {
      return `${this.$api}${this.data.profile.mainPicture.thumb}`;
    },

    profileLink() {
      return `/profile/${this.data.profile.id}`;
    },
  },
};
</script>
